import { defineStore } from 'pinia'

export const MessageBox = defineStore('MessageBox', {
    state: () => ({
        shown: false,
        message: '',
        buttonText: 'Tamam',
        buttonAction: () => {},
        keepOpen: false,
        showCloseButton: false,
        cancelButton: null,
        style: {},
        mss: null
    }),

    actions: {
        setTitle(title) {
            this.title = title;
            return this;
        },

        setDescription(description) {
            this.description = description;
            return this;
        },

        show(options) {
            this.shown = true;
            this.buttonText = options?.buttonText || this.buttonText;
            this.message = options?.message || this.message;
            this.buttonAction = options?.buttonAction || this.buttonAction;
            this.keepOpen = options?.keepOpen || this.keepOpen;
            this.showCloseButton = options?.showCloseButton || this.showCloseButton;
            this.cancelButton = options?.cancelButton || null;
            this.style = options?.style || {};
            this.mss = options?.mss || null;
        },

        hide(onlyClose) {
            this.$reset();
            if (onlyClose) {
                this.shown = false;
                return true;
            }
            this.shown = this.keepOpen;
        }
    }
});
